export default __webpack_public_path__ + "static/media/pin-my-location.f550f1f0.svg";